export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const NO_IMAGE = '-';

export default { BACKEND_URL, NO_IMAGE };
